import { render } from "./ModalVideo.vue?vue&type=template&id=02f77004&scoped=true"
import script from "./ModalVideo.vue?vue&type=script&lang=js"
export * from "./ModalVideo.vue?vue&type=script&lang=js"

import "./ModalVideo.vue?vue&type=style&index=0&id=02f77004&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f77004"]])

export default __exports__